import React from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../../translation/namespace';
import IParameter from '../../../../types/IParameter';
import FormInput from '../../../molecules/Form/components/FormInput/FormInput';
import FormsFieldset from '../../../molecules/Form/components/FormsFieldset/FormsFieldset';
import FormsRow from '../../../molecules/Form/components/FormsRow/FormsRow';
import FormsColumn from '../../../molecules/Form/components/FormsColumn/FormsColumn';
import { renderFormElement } from '../UserRegistrationForm.utils';
import { AUTOCOMPLETE_VALUES } from '../UserRegistrationForm.enums';
import { getPatternMismatchErrorMessage } from '../../../molecules/Form/FormFactory';
import { useFormContext } from '../../../molecules/Form';
import { FieldsetLegend } from '../../../molecules/Form/components/FormsFieldset/partials/FieldsetLegend';

type FieldsetContactDataProps = {
  fieldSet: string;
  inputs: IParameter[];
};

const ID_SUFFIX = 'registration';

const PHONE_NUMBER_PARAMS = ['phoneAreaCode', 'phoneLineNumber', 'phonePrefix'];

export function FieldsetContactData(props: FieldsetContactDataProps) {
  const { t } = useTranslation(Namespace.UserRegistrationForm);
  const { onChange } = useFormContext();

  // can be missing if phoneNumber is not configured in the portal
  const phoneParams = props.inputs.filter(input => PHONE_NUMBER_PARAMS.includes(input.name));
  const otherParams = props.inputs.filter(input => !PHONE_NUMBER_PARAMS.includes(input.name));
  const legend = t(`legends.${props.fieldSet}`);
  const helpText = t('labelHelpText.phoneLegend');

  return (
    <FormsFieldset key={props.fieldSet} legend={legend}>
      {phoneParams.length ? (
        <FormsFieldset>
          <FieldsetLegend className="form-fieldset__legend--blank" id={props.fieldSet} helpText={helpText}>
            {t(`${Namespace.glossary}:phone`)}
          </FieldsetLegend>
          <FormsRow key="phoneNumberRow-registration">
            {phoneParams.map(parameter => (
              <FormsColumn key={parameter.name}>
                <FormInput
                  id={`${parameter.name}-${ID_SUFFIX}`}
                  key={`${parameter.name}-${ID_SUFFIX}`}
                  // @ts-expect-error needs typing
                  autoComplete={AUTOCOMPLETE_VALUES[parameter.name]}
                  type={parameter.type}
                  name={parameter.name}
                  required={parameter.required}
                  readOnly={parameter.readonly || parameter.constraints?.readonly}
                  labelTitle={t(`labels.${parameter.name}`)}
                  // labelHelpText={getHelpText(parameter.name, parameter.type)}
                  value={parameter.value}
                  issues={parameter.getIssues()}
                  minLength={parameter.constraints?.minLength}
                  maxLength={parameter.constraints?.maxLength}
                  // number constraints
                  min={parameter.constraints?.min}
                  max={parameter.constraints?.max}
                  step={parameter.constraints?.step}
                  pattern={parameter.constraints?.pattern}
                  // custom pattern mismatch errors only for types where the browser native message is not used.
                  patternMismatchErrorMessage={getPatternMismatchErrorMessage(parameter.name, parameter.type)}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    onChange(parameter.name, event.target.value)
                  }
                />
              </FormsColumn>
            ))}
          </FormsRow>
        </FormsFieldset>
      ) : null}
      {otherParams.map(parameter => renderFormElement(parameter, onChange, t))}
    </FormsFieldset>
  );
}
